/* ==========================================================================
   PWR STORY
   The ONLY behaviour the Animation Engine does not cleanly provide: a
   count-up that PRESERVES a numeric stat's prefix/suffix (e.g. "20+",
   "1000+") and leaves non-numeric stats (e.g. "Premium") untouched.

   Everything else is reused, NOT reimplemented:
     - Fade / scale / cascade reveal -> engine [data-pwr-reveal] / -group
     - Section lifecycle             -> JS Core (registerSection)
     - Reduced motion, raf, in-view  -> JS Core / utils / IntersectionObserver

   Why not the engine's [data-pwr-countup]? That helper overwrites textContent
   with the bare number, dropping the "+" suffix and zeroing non-numeric text.
   This controller uses its own hook, data-pwr-stat, and formats around it.
   Registered via PWR.registerSection => Theme Editor safe, no double init.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.PWR || !window.PWR.registerSection) return;
  var PWR = window.PWR;
  var utils = PWR.utils;
  var Section = PWR.Section;

  function Story(root) {
    Section.call(this, root);
  }
  Story.prototype = Object.create(Section.prototype);
  Story.prototype.constructor = Story;

  Story.prototype.init = function () {
    this.stats = this.$$('[data-pwr-stat]');
    if (!this.stats.length) return;

    // Reduced motion or no observer: settle to final values immediately.
    if (utils.prefersReducedMotion() || !('IntersectionObserver' in window)) {
      for (var i = 0; i < this.stats.length; i++) this._settle(this.stats[i]);
      return;
    }

    var self = this;
    this._io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        self._run(entry.target);
        self._io.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    this.stats.forEach(function (el) { self._io.observe(el); });
    this.addCleanup(function () { if (self._io) self._io.disconnect(); });
  };

  /* Parse "1000+" -> { value:1000, prefix:'', suffix:'+' }.
     Non-numeric ("Premium") -> { value:null }. */
  Story.prototype._parse = function (el) {
    var raw = (el.getAttribute('data-pwr-stat') || el.textContent || '').trim();
    var match = raw.match(/^(\D*)(\d[\d,]*)(.*)$/);
    if (!match) return { value: null, raw: raw };
    return {
      value: parseInt(match[2].replace(/,/g, ''), 10),
      prefix: match[1] || '',
      suffix: match[3] || '',
      raw: raw
    };
  };

  Story.prototype._settle = function (el) {
    var p = this._parse(el);
    if (p.value === null) { el.textContent = p.raw; return; }
    el.textContent = p.prefix + this._format(p.value) + p.suffix;
  };

  Story.prototype._run = function (el) {
    var p = this._parse(el);
    if (p.value === null) { el.textContent = p.raw; return; }

    var duration = parseInt(el.getAttribute('data-duration'), 10) || 1100;
    var start = performance.now();
    var self = this;
    var tick = function (now) {
      var t = utils.clamp((now - start) / duration, 0, 1);
      var eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
      var current = Math.round(p.value * eased);
      el.textContent = p.prefix + self._format(current) + p.suffix;
      if (t < 1) window.requestAnimationFrame(tick);
    };
    window.requestAnimationFrame(tick);
  };

  /* Thousands separator, locale-aware where available. */
  Story.prototype._format = function (n) {
    try { return n.toLocaleString(); } catch (e) { return String(n); }
  };

  PWR.registerSection('pwr-story', function (root) { return new Story(root); });
})();
